export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-black">
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-xl border-b border-red-500/30">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            <a href="/" className="flex items-center gap-4 cursor-pointer">
              <div className="w-14 h-14 bg-gradient-to-br from-red-500 via-orange-500 to-yellow-500 rounded-full flex items-center justify-center shadow-xl shadow-red-500/50 border-2 border-red-400/50">
                <i className="ri-megaphone-line text-2xl text-white"></i>
              </div>
              <div>
                <h1 className="text-3xl font-black text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                  Office <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">WoW</span>
                </h1>
                <p className="text-xs text-red-400 font-semibold tracking-wide" style={{ fontFamily: '"Montserrat", sans-serif' }}>Creative Agency</p>
              </div>
            </a>
          </div>
        </div>
      </header>

      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-5xl font-black text-white mb-12" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
              プライバシーポリシー
            </h2>
            
            <div className="bg-white/5 backdrop-blur-xl rounded-3xl border border-red-500/30 p-8 space-y-8">
              <section>
                <h3 className="text-2xl font-bold text-red-400 mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>1. 個人情報の取り扱いについて</h3>
                <p className="text-gray-300 leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  合同会社オフィスWoW（以下「当社」）は、お客様の個人情報を適切に保護することが社会的責務であると考え、以下の方針に基づき個人情報の保護に努めます。
                </p>
              </section>

              <section>
                <h3 className="text-2xl font-bold text-red-400 mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>2. 個人情報の収集</h3>
                <p className="text-gray-300 leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  当社は、お客様から個人情報を収集する際には、その目的を明確にし、必要な範囲内で適法かつ公正な手段により収集いたします。
                </p>
              </section>

              <section>
                <h3 className="text-2xl font-bold text-red-400 mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>3. 個人情報の利用目的</h3>
                <p className="text-gray-300 leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  収集した個人情報は、お問い合わせへの対応、サービスの提供、その他当社の事業活動に必要な範囲内でのみ利用いたします。
                </p>
              </section>

              <section>
                <h3 className="text-2xl font-bold text-red-400 mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>4. 個人情報の第三者提供</h3>
                <p className="text-gray-300 leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  当社は、法令に基づく場合を除き、お客様の同意なく個人情報を第三者に提供することはありません。
                </p>
              </section>

              <section>
                <h3 className="text-2xl font-bold text-red-400 mb-4" style={{ fontFamily: '"Montserrat", sans-serif' }}>5. お問い合わせ</h3>
                <p className="text-gray-300 leading-relaxed" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  個人情報の取り扱いに関するお問い合わせは、当社までご連絡ください。<br />
                  所在地：神奈川県相模原市南区松が枝町1番25号
                </p>
              </section>
            </div>

            <div className="mt-12 text-center">
              <a href="/" className="bg-gradient-to-r from-red-500 to-orange-500 text-white px-8 py-4 rounded-full hover:shadow-xl hover:shadow-red-500/50 transition-all font-bold text-lg tracking-wide whitespace-nowrap cursor-pointer" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                トップページに戻る
              </a>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-black border-t border-red-500/20 py-8">
        <div className="container mx-auto px-6 text-center">
          <p className="text-gray-500 text-sm" style={{ fontFamily: '"Montserrat", sans-serif' }}>
            &copy; 2025 合同会社オフィスWoW All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
